export default {
  metrics: {
    gs: {
      label: 'プレイ可能な表示回数',
      desc: '試用素材が表示された回数（再試用は試用表示には含まれません）。',
      group: 'プレイ可能な表示',
    },
    fi: {
      label: '初回インタラクション数',
      scene_label: 'シーン初回インタラクション数',
      desc: 'ユーザーが初めてクリック、ドラッグなどのインタラクションを発生させた回数。',
      group: '初回インタラクション',
    },
    ge: {
      label: '試遊終了数',
      desc: 'ユーザーが終了シーンに到達したか、特定の終了条件を満たした回数。',
      group: 'ゲーム終了',
    },
    vi: {
      label: '有効なインタラクション数',
      desc: 'ユーザーがゲームロジックのインタラクションを発生させた回数。',
    },
    vi_avg: {
      label: '平均有効インタラクション数',
      desc: '平均して、1回の表示でユーザーがゲームロジックのインタラクションを発生させた回数。',
    },
    wc: {
      label: '閉じられたクリエイティブ数',
      desc: 'ユーザーが閉じるボタンを押した回数。',
    },
    install: {
      label: 'リダイレクト数',
      scene_label: 'シーンリダイレクト数',
      desc: 'ユーザーが素材内で他のURLに移動したか、アプリストアに移動した回数。',
    },
    replay: {
      label: '再プレイ',
      desc: 'ユーザーが再プレイを行った回数。',
    },
    fi_time: {
      label: '初回インタラクション時の時間',
      desc: '素材表示から初回インタラクションまでの平均時間（初回インタラクションが発生しなかった場合は含まれません）。',
    },
    ge_time: {
      label: 'ゲームプレイ時間',
      desc: 'ゲームプレイ中に離脱し、他のURLやアプリストアに移動しなかった回数。',
    },
    loss: {
      label: 'シーン離脱数',
      desc: 'ユーザーが離脱し、他のURLやアプリストアに移動しなかった回数。',
    },
    loss_after_fi: {
      label: 'インタラクション後の離脱数',
      scene_label:
        'シーンインタラクション後に離脱し、他のURLやアプリストアに移動しなかった回数。',
      desc: 'ゲームプレイ中に離脱し、他のURLやアプリストアに移動しなかった回数。',
    },
    loss_playing: {
      label: 'ゲームプレイ中の離脱数',
      desc: 'ゲームプレイ後の離脱し、他のURLやアプリストアに移動しなかった回数。',
    },
    loss_ending: {
      label: 'ゲームプレイ後の離脱数',
      desc: 'ゲームプレイ後に離脱し、他のURLやアプリストアに移動しなかった回数。',
    },
    loss_fi: {
      label: 'ゲームプレイ前の離脱数',
      scene_label: 'シーン離脱率',
      desc: 'シーン離脱数/シーン到達数',
    },
    loss_rate: {
      label: 'インタラクション前の離脱率',
      desc: 'シーンインタラクション前の離脱数/試遊デモ数',
    },
    loss_fi_rate: {
      label: 'シーンインタラクション前の離脱率',
      desc: 'シーンインタラクション前の離脱数/シーン到達数',
      scene_label: 'インタラクション後の離脱率',
      scene_desc: 'インタラクション後の離脱数/試遊デモ数',
    },
    loss_after_fi_rate: {
      label: 'シーンインタラクション後の離脱率',
      desc: 'シーンインタラクション後の離脱数/シーン到達数',
      scene_label: 'ゲームプレイ中の離脱率',
      scene_desc: 'ゲームプレイ中の離脱数/ゲームプレイデモ数',
    },
    loss_playing_rate: {
      label: 'ゲームプレイ終了の離脱率',
      desc: 'ゲームプレイ終了の離脱数/ゲームプレイデモ数',
    },
    loss_ending_rate: {
      label: 'リダイレクト率',
      desc: 'リダイレクト数/試遊デモ数',
    },
    install_rate: {
      label: 'シーンリダイレクト率',
      desc: 'シーンリダイレクト数/シーン到達数',
      scene_label: '試遊中のリダイレクト率',
      scene_desc: 'シーンのリダイレクト回数/シーン到達回数',
    },
    install_playing_rate: {
      label: 'ゲームプレイ中のリダイレクト率',
      desc: 'ゲームプレイ中のリダイレクト数/ゲームプレイ展示数',
    },
    install_ending_rate: {
      label: 'ゲームプレイ終了のリダイレクト率',
      desc: 'ゲームプレイ終了のリダイレクト数/ゲームプレイ展示数',
    },
    fi_rate: {
      label: '初回インタラクション率',
      desc: '初回インタラクション数/試遊展示数',
      scene_label: 'シーン初回インタラクション率',
      scene_desc: 'シーン初回インタラクション数/シーン到達数',
    },
    ge_rate: {
      label: 'ゲームプレイ終了率',
      desc: 'ゲームプレイ終了数/ゲームプレイ展示数',
    },
    rp_rate: {
      label: '再ゲームプレイ率',
      desc: '再ゲームプレイ数/ゲームプレイ展示数',
    },
    reach: {
      label: 'シーン到達数',
      desc: 'ユーザーが現在のシーンに到達した回数。',
    },
    go_next: {
      label: '他のシーンへのリダイレクト数',
      desc: 'ユーザーが現在のシーンから他のシーンに移動した回数。',
    },
    go_next_rate: {
      label: '他のシーンへのリダイレクト率',
      desc: '他のシーンへのリダイレクト数/シーン到達数',
    },
    stay_time: {
      label: 'シーン滞在時間',
      desc: 'ユーザーがそのシーンに滞在した平均時間（他のシーンに移動しなかった場合を含む）。',
    },
    install_playing: {
      label: 'ゲームプレイ中のリダイレクト数',
      desc: 'ユーザーがゲームプレイ中に他のURLやアプリストアに移動した回数。',
    },
    install_ending: {
      label: 'ゲームプレイ終了時のリダイレクト数',
      desc: 'ユーザーが試遊終了後に他のURLやアプリストアに移動した回数。',
    },
    ge_auto: {
      label: '自動ゲームプレイ終了数',
      desc: '素材自体または広告プラットフォームのロジックによって自動的にトリガーされた、ユーザーが手動でトリガーされないゲームプレイ終了の回数。',
    },
    ge_manual: {
      label: '手動ゲームプレイ終了数',
      desc: 'ユーザーが手動でトリガーしたゲームプレイ終了の回数。',
    },
    install_auto: {
      label: '自動リダイレクト数',
      desc: '素材自体または広告プラットフォームのロジックによって自動的にトリガーされた、ユーザーが手動でトリガーされないリダイレクトの回数。',
    },
    install_manual: {
      label: '手動リダイレクト数',
      desc: 'ユーザーが手動でトリガーしたリダイレクトの回数。',
    },
    title: 'メトリクス',
  },
  metricsType: {
    action: 'インタラクションメトリクス',
    translate: '変換メトリクス',
    loss: '離脱メトリクス',
    custom: 'カスタムトラッキングメトリクス',
    placeAds: '広告パフォーマンス指標',
  },
  metricsGroupType: {
    ads: '広告パフォーマンスデータ',
    pl: 'インタラクションデータ',
  },
  adsMetrics: {
    cost: {
      label: 'コスト',
    },
    click: {
      label: 'クリック数',
    },
    impression: {
      label: 'インプレッション数',
    },
    install: {
      label: 'コンバージョン数',
    },
    ctr: {
      label: 'CTR',
      desc: 'クリック数/インプレッション数',
    },
    cvr: {
      label: '転換率',
      desc: 'CVR',
    },
    ivr: {
      label: 'IVR',
      desc: 'コンバージョン数/インプレッション数',
    },
    cpi: {
      label: 'CPI',
      desc: 'コスト/コンバージョン',
    },
    cpm: {
      label: 'CPM',
      desc: 'コスト/(インプレッション*1000)',
    },
    cpc: {
      label: 'CPC',
      desc: 'コスト/クリック数',
    },
    date_cost: {
      label: '1日の広告費用',
    },
    date_impression: {
      label: '日平均インプレッション数',
    },
    date_click: {
      label: '日平均クリック数',
    },
    date_install: {
      label: '日平均コンバージョン数',
    },
  },
  breakdowns: {
    ad_output_type: '広告表示タイプ',
    material_name: '広告プラットフォームの素材名',
    material_type: 'クリエイティブタイプ',
    package_name: '配信プロダクト',
    material_source: 'クリエイティブソース',
    template_id: 'プレイアブルテンプレート',
    campaign_id: 'キャンペーン',
    adset_id: '広告グループ',
    basic_id: 'クリエイティブIDと名称',
    fingerprint: 'Playturboのクリエイティブ名とフィンガープリント',
    fingerprint_desc:
      '一部のクリエイティブにPlayturboのクリエイティブ名がない場合、広告プラットフォームのクリエイティブ名が表示されます。もし広告プラットフォームのクリエイティブ名がなければ、クリエイティブの指紋が表示されます。',
    ad_id: '広告',
    period: '日付',
    traffic_type: '広告ネットワーク',
    platform: 'OS',
    country_code: '配信地域',
    project_id: 'プロジェクト名とID',
    ad_type: '広告タイプ',
    mid: '素材ID',
    product_id: '関連製品',
    publish_time: '生成時間',
    scene: 'シーン',
    title: 'ディメンション',
    onlyMintegralTip:
      'このフィールドはMintegralの広告プラットフォームの場合にのみ使用可能です。',
    onlyUnityTip:
      'このフィールドはUnityの広告プラットフォームの場合にのみ使用可能です。',
    tooltipAdDataTips: {
      datarange:
        '広告アカウントをバインドし、プレイ可能な素材データの範囲が「取得しない」に設定されていないことを確認してください。',
      mars: 'プレイ可能な素材に対して埋め込みイベントの追加を許可してください。',
    },
    onlyIronsourceTip: {
      noSupport: 'Ironsourceは現在サポートされていません',
    },
  },
  title: 'クリエイティブインサイト',
  overview: {
    title: 'データ概要（Beta）',
    desc: 'このページでは、広告アカウントのパフォーマンスデータの概要を説明します。さまざまな広告アカウントやクリエイティブ素材の種類ごとの広告パフォーマンスを迅速に把握することができます。',
    data: {
      title: '過去7日間のデータ',
      account: 'アカウント',
      accountAll: '全て',
      accountBtn: '関連広告主を編集',
      adData: '広告パフォーマンスデータ',
      plData: 'クリエイティブデータ',
      impression: '露出されたクリエイティブ数',
      impressionTips: '過去7日間のインプレッション数が0より大きい素材の数',
      minimumQuantity: '露出回数の多いクリエイティブ数',
      minimumQuantityTips:
        '過去7日間のインプレッション数が3000より大きいクリエイティブの数',
    },
    chart: {
      title: '比較分析',
      detailTitle: '詳細データ',
      detailTooltip:
        '1回の広告表示に複数の素材が含まれる場合、表示回数、クリック数、インストール数、費用は各クリエイティブごとに1つのデータとして計算されます。',
    },
    single: {
      title: '個別プロダクトのクリエイティブの状況',
    },
    overall: {
      title: '全体的なクリエイティブの状況',
      subTitle: {
        all: 'クリエイティブディメンションに基づくグラフは、Playturboのプレイ可能な素材を含みます。',
        mtg: '広告クリエイティブディメンションに基づくグラフは、広告アカウント内のすべてのプレイ可能な素材を含みます。',
      },
      tooltips: {
        all: '広告アカウント内のすべての素材を分析するには、個別のチャネルにアクセスしてください。',
      },
    },
    material: {
      source: {
        title: 'クリエイティブのソース比較',
      },
      pv: {
        title: 'クリエイティブのボリューム状況',
      },
      install: {
        title: 'クリエイティブのコンバージョン状況',
      },
      pl: {
        title: 'クリエイティブの状況',
      },
      alldata: {
        title: 'すべてのデータ',
      },
    },
  },
  tips: {
    materialTypeDisabled:
      'このディメンションを表示するには、クリエイティブタイプのフィルタリングを行ってください。',
    selectedReason:
      '現在のディメンションでは、この指標を表示できません。もう一度選択してください。',
    filteredReason:
      '現在のフィルターオプションでは、この指標を表示できません。もう一度選択してください。',
    daterange: {
      max: '選択した日付が指定された最大{max}日数を超えています',
    },
  },
  chart: {
    breakdown: {
      ruleTips:
        '最大で1つのディメンションが許可されています。カスタムレポートで変更してください。',
    },
    filter: {
      day: {
        label: '日ごと',
        desc: '日ごと集計',
      },
      week: {
        label: '週ごと',
        desc: '毎週ごとの集計',
      },
      month: {
        label: '月ごと',
        desc: '月ごと集計',
      },
    },
    exceedTip:
      '* 現在の周期内での指標データの合計は、降順に並べ替えて上位 {max} を表示します。',
  },
  tz: {
    label: 'タイムゾーン',
    all: {
      tip: '異なる広告プラットフォームに対応するタイムゾーンが異なります。{text}',
      tipBtnText: '詳細はこちらをクリック',
    },
    mtg: {
      tip: 'メインアカウントの設定を適用',
    },
    updateTime: '最終更新日',
    updateTimeTip: '{time} 前日のデータを更新',
  },
  material: {
    title: 'PLパフォーマンス分析',
    dataAnalysis: {
      title: '詳細データ',
      filterDialog: {
        btnText: 'カスタムレポート',
        filter: 'フィルタ',
        column: 'カスタム列',
      },
    },
    detailTitle: '素材分析の詳細',
    detailTitleDesc:
      '各シーンおよびカスタムトラッキングポイントでのユーザー到達、離脱、変換を分析する',
    analyze: {
      tab: {
        scene: 'シーン分析',
        journey: 'ユーザージャーニー分析',
      },
      projectType: {
        subs: 'サブスクリプションプロジェクト',
        custom: 'カスタマイズプロジェクト',
      },
    },
    DetailData: '詳細データ',
    playable: {
      description:
        'プレイ可能素材の広告パフォーマンスデータとトラッキングデータに基づいて、多次元の素材分析を提供します。これらのデータを通じて、ユーザーの行動を洞察し、素材の効果を評価し、さらなる素材の最適化のための根拠を提供することができます。',
      interaction: {
        description:
          'プレイアブル素材のトラッキングデータに基づいて、ユーザーの旅程とシナリオの次元からのユーザーインタラクションの分析を提供します。これらのデータを活用して、素材の潜在的な最適化ポイントを特定できます。',
      },
    },
    descriptionTooltip:
      'トラッキングデータは参考値です。素材内のユーザーの相互作用を分析するためであり、最終的な効果を決定づけるものではありません。',
    descTip:
      'トラッキングデータは参考値です。素材内のユーザーの相互作用を分析するためであり、最終的な効果を決定づけるものではありません。',
    unsupportAnalyze: {
      noaccess: 'アクセス権がありません',
      noscene:
        'このクリエイティブはシーンごとに区別されていないため、分析はサポートされていません。',
    },
    projectFilter: {
      select: '選択してください',
      empty: 'まだクリエイティブバージョンが選択されていません',
    },
    preview: {
      title: 'プレビュー',
      selectText: 'プレビューを開始',
      sceneName: 'シーン{n}',
      sceneFrom: 'シーン{fromScene} からプレビューを開始',
      sceneDlLoss: 'シーン分布',
    },
  },
  event: {
    title: 'イベント分析',
    desc: 'ユーザーがトリガーした複数のイベントを収集し、イベントデータの分析を提供します。',
    descTip:
      'トラッキングデータは参考までで、素材内のユーザーの相互作用を分析するためであり、最終的な効果を表していません。',
    overview: {
      title: '過去7日間のデータ',
      subTitle: '今回のサイクルで表示された素材数： {count}',
      fi_time_average: '初回インタラクション時間',
      ge_time_average: '試用時間',
      ge_manual_rate: 'インタラクション後の終了率',
      adsData: '広告パフォーマンスデータ',
      adsDataTips: {
        all: 'すべての承認済み広告アカウントにおけるプレイアブル素材の配信データを集計します。',
        mtg: '{trafficType}の認可された広告アカウントにおいて、プレイアブル素材の配信データを集計します。',
      },
      plData: 'ユーザーのインタラクション状況',
      plDataTips: {
        all: 'Playturboアカウントで生成されたすべてのプレイアブル素材のインタラクティブデータを集計します。',
        mtg: 'Playturboアカウントで生成された{trafficType}のプレイアブル素材のインタラクティブデータを集計します。',
        other:
          'このPlayturboアカウントによって出力され、このチャネルを通じて投放された全てのプレイアブル素材のインタラクションデータの集計',
      },
    },
    trend: {
      title: 'トレンド分析',
      subTitle: '指定された時間枠内での選択したデータ指標の変化傾向。',
      unknown: '不明',
      topTips:
        'このサイクル内の合計指標データは、大きなものから順に選択して表示します。',
      filterDialog: {
        btnText: 'カスタムグラフ',
        filter: 'フィルタ',
        mab: 'メトリックディメンション',
      },
    },
    detail: '詳細データ',
  },
  customColumn: {
    title: 'カスタム列',
    placeholder: '列のフィルタ',
    materialRule: '少なくとも{num}個の素材情報を選択してください。',
    metricsRule: '少なくとも {num} の指標を選択してください',
    breakdownRule: '少なくとも {num} のディメンションを選択してください',
    breakdownsRule: '{min}-{max} のディメンションを選択してください',
    materialInfo: 'クリエイティブ情報',
    materialInfoProduct: 'クリエイティブ制作情報',
    materialInfoPoint: 'クリエイティブ配信情報',
    selected: '選択済 {count} 列',
    clear: 'クリア',
    emptyData: 'データなし',
    fixedMessage: '上の列にドラッグして固定表示',
    cancel: 'キャンセル',
    confirm: '確定',
  },
  export: {
    title: 'データのエクスポート',
    message: 'エクスポートには時間がかかる場合があります。お待ちください。',
    error: 'エクスポートに失敗しました。もう一度エクスポートしてください。',
  },
  blankTemplate: '空白で制作',
  filter: {
    productNameOrId: 'プロジェクト名とID',
    product_id: 'プロジェクトID',
    product_name: 'プロジェクト名',
    pleaseInput: '入力してください',
    search: '検索',
    inputProductId: '関連製品を入力してください',
    publish_time: 'クリエイティブ作成日時',
    pleaseSelect: '選択してください',
    showTime: {
      first: 'ファーストセッション',
      all: 'すべてのセッション回数を集計',
    },
    adType: {
      rewardedVideo: 'リワードビデオ（報酬付き動画広告）',
      interstitialVideo:
        'インタースティシャルビデオ（動画型インタースティシャル広告）',
    },
    platform: {
      ios: 'iOS',
      android: 'Android',
    },
    adOutputType: {
      videoAndCommonEndcard: 'ビデオ+通常エンドカード',
      videoAndDynamicEndcard: 'ビデオ+ダイナミックエンドカード',
      videoAndPlayable: 'ビデオ+プレイ',
      onlyVideo: 'ビデオのみ',
      onlyPlayable: 'プレイアブルのみ',
      other: 'その他',
    },
    trafficType: {
      all: '総計',
    },
    materialType: {
      pl: 'プレイアブル',
      video: 'ビデオ',
      graphic: '画像',
      unknown: '未知',
    },
    materialSource: {
      playturboTemplate: 'Playturboスキン',
      playsmart: 'Playturbo自由編集',
      mws: 'MWSカスタム',
      adPlatform: '広告プラットフォームのアップロード',
      unknown: '未知',
    },
    total: {
      filters: 'フィルタ',
      columns: '列',
    },
  },
  table: {
    operation: '操作',
  },
  searchFilter: {
    clear: 'クリア',
    allFilter: 'すべてのフィルタ',
    filter: 'フィルタ',
    cancel: 'キャンセル',
    confirm: '確定',
  },
  ringRatio: '対前月 {value}',
  journey: {
    title: 'ユーザージャーニー分析',
    filter: {
      label: 'すべてのフィルタ',
    },
    actions: {
      cancel: 'キャンセル',
      save: 'ディスプレイジャーニー',
      edit: '編集',
    },
    disabledEditTips:
      'この素材はテンプレート/カスタマイズ製作用であり、ユーザージャーニーの手動設定は不要です。',
  },
  searchEmpty: {
    tips: '検索結果がありません',
  },
  searchForbidden: {
    tips: '検索内容をクリアしてから選択可能です',
  },
}
